import { useEffect } from 'react';

import { useUserFetch } from '@24i/nxg-sdk-smartott-shared/src/hooks/query/user/useUserFetch';
import { useUserProfilesFetch } from '@24i/nxg-sdk-smartott-shared/src/hooks/query/user/useUserProfilesFetch';
import { useFeature } from '@24i/nxg-sdk-smartott-shared/src/context/AppSettingsData';

import { useStore } from '../../ApplicationStore';
import { ApplicationStates } from '../constants';

export const useLoadUserAndProfile = (appState: ApplicationStates) => {
    const { fetch: fetchUser } = useUserFetch();
    const { fetch: fetchUserProfiles } = useUserProfilesFetch();
    const { setUserData, setProfilesAndPossiblySelectOne } = useStore();
    const profilesEnabled = useFeature('accounts')?.select_profiles || false;

    useEffect(() => {
        if (appState !== ApplicationStates.initialized) return;
        fetchUser().then((user) => {
            setUserData(user);
        });

        if (!profilesEnabled) return;
        // Fetch user profiles only if the feature is enabled
        fetchUserProfiles().then((profiles) => {
            setProfilesAndPossiblySelectOne(profiles);
        });
    }, [appState, profilesEnabled]);
};
